import { CellComponentProps } from '@melements/front-components/dist/components/list/table/body/cell/Cell.types';
import { LocaleContext } from '@melements/front-components/dist/context';
import React, { useContext } from 'react';
import { Button } from 'shared';

import { Tpp } from '../../../../../store/api/tpps/tpps.types';
import { ActionButtonWrapper } from '../../../Dashboard.styles';

export const EditButton = ({ value: callback, data }: CellComponentProps<any>) => {
  const localeContext = useContext(LocaleContext);

  const showEditTppModal = () => {
    callback(data as Tpp);
  };

  return (
    <ActionButtonWrapper>
      <Button type="leading" className="button--action" onClick={showEditTppModal}>
        {localeContext.formatMessage({ id: 'TPPS.TABLE.ACTION.EDIT' })}
      </Button>
    </ActionButtonWrapper>
  );
};
